var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewUsersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.833,
    height: 30,
    viewBox: "0 0 25.833 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M23.317,17.25a7.5,7.5,0,1,0-7.535-7.5A7.514,7.514,0,0,0,23.317,17.25Zm5.167,2.143h-.558a10.446,10.446,0,0,1-9.217,0H18.15a7.734,7.734,0,0,0-7.75,7.714v1.929a3.223,3.223,0,0,0,3.229,3.214H33a3.223,3.223,0,0,0,3.229-3.214V27.107A7.734,7.734,0,0,0,28.483,19.393Z",
    transform: "translate(-10.4 -2.25)",
    fill: "#bebebe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUsersIcon);
export default __webpack_public_path__ + "static/media/new-users-icon.0411d58e.svg";
export { ForwardRef as ReactComponent };